import {AxiosResponse} from "axios";
import request from "@/utils/request";
import { AppModule } from '@/store/modules/app';

import DictsCacheService from "@/services/dicts_cache_service";
import UserAccessService from "@/services/user_access_service";
import UserManagerService from "@/services/data/user_manager";
import EcoObjectsService from "@/services/eco-objects-service";
import YearService from "@/services/years-service";
import PresetService from "@/services/user_preset_service";
import MonitoringService from "@/views/admin/monitoring/service";

class ShareService {

  public acceptPopup: any;
  private importPopup: any;

  public share_year_id: string | null;
  public share_cut_id: string | null;
  public share_filial_id: number | null;
  public share_heat_node_id: number | null;

  public initializing: boolean = false;

  constructor() {
    this.acceptPopup = {
      visible: false
    };
    this.importPopup = {
      visible: false
    };
    this.share_year_id = null;
    this.share_cut_id = null;
    this.share_filial_id = null;
    this.share_heat_node_id = null;
  }

  get acceptPopupVisible() {
    return this.acceptPopup.visible
  }
  get importPopupVisible() {
    return this.importPopup.visible
  }

  public showAcceptPopup() {
    this.acceptPopup.visible = true
  }
  public closeAcceptPopup() {
    this.acceptPopup.visible = false
  }
  public showImportPopup() {
    this.importPopup.visible = true
  }
  public closeImportPopup() {
    this.importPopup.visible = false
  }


  // Если будет выполнено обновление кэша c флаго freezeAppWhileLoad во время работы программы,
  // то все компоненты внутри внутри AppMount будут перемонтированы
  async loadAllCaches(freezeAppWhileLoad: boolean = true) {
    this.initializing = freezeAppWhileLoad;
    try {
      await Promise.all([
        MonitoringService.getGatewayStatus(),
        DictsCacheService.update_dicts_cache(),
        UserAccessService.load_cache(),
        UserManagerService.getCurrentUser(),
        EcoObjectsService.update_cache(),
        YearService.updateFromDb(),
        PresetService.load_cache()
      ]);
    } catch (e) {

    }
    this.initializing = false;
  }

  public async CheckConnectionState() {

    try {
      const resp: AxiosResponse["data"] = await request({
        url: `/ping`,
        method: 'get',
      });

      if (resp) {
        AppModule.SetConnectionState(true)
      }
    } catch (e) {
      setTimeout(() => {
        this.CheckConnectionState();
      }, 3000);
    }
  }
}

export default new ShareService();
